module.exports = function () {
	'use strict';

	require('./stylus/_freeHostedGallery.styl');
	require('./stylus/_freeHostedVideos.styl');

	require('./options/options.opt')(fox);

	var require__template = require.context('fox-dynamic-injection!fox-template-loader!./templates', false, /\.tpl$/);
	var template__files = require__template.keys();

	template__files.forEach(function (file) {require__template(file)(fox);});
};


//////////////////
// WEBPACK FOOTER
// ./components/fhg/index.js
// module id = 467
// module chunks = 4